import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { getSettings } from "./settings.thunk";
import { isError, isIdle, isLoading, isSuccess } from "@/app/utils/asyncStatus";

/**
 * Alan bazlı seçiciler — useSettings() tüm slice'a abone olduğu için, settings
 * içindeki HERHANGİ bir alan değiştiğinde onu kullanan her bileşen render olur.
 * FallbackImage sayfada 456 kez var; tek bir string alanı için tüm slice'a abone
 * olmasının anlamı yok. Primitif dönüldüğü için referans değil DEĞER karşılaştırılır.
 */
export const useSiteLogo = () =>
  useAppSelector((store) => store.settings.data?.site_logo);

export const useSiteName = () =>
  useAppSelector((store) => store.settings.data?.site_name);

const useSettings = () => {
  const dispatch = useAppDispatch();
  const {
    data: settings,
    error: settingsError,
    status: settingsStatus,
  } = useAppSelector((store) => store.settings);

  const fetchSettings = useCallback(() => {
    dispatch(getSettings());
  }, [dispatch]);

  return {
    settings,
    settingsError,
    settingsStatus,
    isIdle: isIdle(settingsStatus),
    isLoading: isLoading(settingsStatus),
    isSuccess: isSuccess(settingsStatus),
    isError: isError(settingsStatus),
    fetchSettings,
  };
};

export default useSettings;
